import {Component, OnInit, inject, DestroyRef} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {UtilService} from 'src/app/services/util.service';
import {CardContainerComponent} from 'src/app/components/card-container/card-container.component';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss'],
  imports: [CardContainerComponent]
})

export class PrivacyPolicyComponent implements OnInit {
  private _utilService = inject(UtilService);
  private _destroyRef = inject(DestroyRef);

  public content: string = '';

  public ngOnInit(): void {
    this._utilService.getPrivacyPolicy()
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((result) => {
        this.content = result;
      });
  }
}
